import { createApp } from 'vue';
import App from './App.vue';
import router from './router.js'; 
import store from './store';
import 'floating-vue/dist/style.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import FloatingVue from 'floating-vue'
import './global.scss'
const app = createApp(App);

app.use(store);
app.use(router);
app.use(FloatingVue)
app.use(Toast, {
  position: "bottom-right",
  timeout: 8000,
  closeOnClick: true,
  pauseOnHover: true,
  draggablePercent: 0.6,
});

app.mount('#app');